import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

import { CatalogFilterSelection } from './catalog-filters';

/** Applied catalog filters, shared with addition panels opened outside the product list. */
@Injectable({ providedIn: 'root' })
export class ShopCatalogFiltersService {
  private readonly appliedSubject = new BehaviorSubject<CatalogFilterSelection[]>([]);

  readonly applied$ = this.appliedSubject.asObservable();
  readonly applied = toSignal(this.appliedSubject, {
    initialValue: [] as CatalogFilterSelection[],
  });

  apply(filters: CatalogFilterSelection[]): void {
    this.appliedSubject.next(filters);
  }

  clear(): void {
    if (this.appliedSubject.value.length === 0) {
      return;
    }
    this.appliedSubject.next([]);
  }
}
